import { ApiProperty } from "@nestjs/swagger";

export class StockIdReq{
    @ApiProperty()
    stockId:number
    @ApiProperty()
    unitId:number
}